import React from "react";
import { Alert, Snackbar } from "@mui/material";

const NtwAlert = ({ open, message, onClose, type, hideDuration }) => {
  return (
    <Snackbar open={open} autoHideDuration={ hideDuration || 6000} onClose={onClose}>
      <Alert
        onClose={onClose}
        severity= {type || "success"}
        variant="filled"
        sx={{
          width: "100%",
          maxWidth: "450px",
          whiteSpace: "normal",  
          wordBreak: "break-word", 
        }}>
        {message}
      </Alert>
    </Snackbar>
  );
};
export default NtwAlert;
